export default __webpack_public_path__ + "static/logo-5-94f0923439f93db3fd068536900ab0f5.png";